import { v4 as uuidv4 } from "uuid"

import { CHECK_KIND_LEAF, WorkflowNode } from "lib/types/workflow"

export const createConditionNode = (): WorkflowNode => ({
  id: uuidv4(),
  type: "condition",
  position: { x: 0, y: 0 },
  data: {
    nodeType: "CONDITION",
    label: "New Condition",
    expression: {
      kind: CHECK_KIND_LEAF,
      // Empty PAYMENT_PROVIDER stub — the editor prompts the user to add at
      // least one field before the leaf becomes valid.
      check: { type: "PAYMENT_PROVIDER", fields: {} }
    }
  }
})

export const createActionNode = (): WorkflowNode => ({
  id: uuidv4(),
  type: "action",
  position: { x: 0, y: 0 },
  data: {
    nodeType: "ACTION",
    label: "New Action",
    actionType: "CANCELLATION"
  }
})
